var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOneContact = function SvgOneContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E5EFF4",
    width: 110,
    height: 110,
    rx: 3.139
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.484 41.9.444 5.08",
    stroke: "#FAA61A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.505 39.401-5.079.444",
    stroke: "#F9AD2E"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FAA61A",
    d: "m52.166 44.188-3.962-3.208M43.007 36.771l-3.962-3.208"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FAA61A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.792 45.424 3.344-3.847M46.773 37.394l4.646-5.346"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FAA61A",
    d: "m44.304 30.173.41 4.696M54.025 37.604l-4.696.411"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.625 45.386 54.75 52.211l.581 1.012a2.746 2.746 0 0 0 3.207 1.253l6.437 3.966c.582.359 1.293.446 1.945.24l14.745-4.668 12.307-8.085 7.932-1.686-2.995-14.086-7.93 1.686-9.756-2.831-18.556 3.944c.418 2.392 1.574 3.781 3.469 4.168 1.895.386 5.038.005 9.43-1.142l3.927 4.96a9.34 9.34 0 0 0 9.264 3.338",
    stroke: "#0171B7",
    strokeWidth: 2.354
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0171B7",
    strokeWidth: 2.354,
    d: "m58.052 50.27-.639-3.003 12.517-5.71 5.044-5.028M58.27 54.567l15.797-5.963M81.665 54.014c-4.657-.767-7.693-4.482-9.11-11.143M76.856 51.689l-14.53 5.215"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#0171B7",
    strokeWidth: 2.354
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.848 67.59 3.233 11.276 6.888-.812 15.636 1.941 14.255-8.177.998-2.047 4.365-2.628.647-2.198 1.454-1.566-.97-3.383-3.118.217-3.254-1.87-19.296 2.474.537-3.571c2.553.385 4.523.006 5.91-1.139 1.388-1.144 2.03-2.707 1.924-4.686L20.76 56.094l-7.69 9.2-5.221 2.295zM35.296 65.46l19.099-4.659M36.168 74.201l12.623-4.436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.142 79.841c2.688-6.2 2.77-11.596.245-16.188M35.84 70.209l18.574-5.771"
  })))));
};
export default SvgOneContact;